<template>
  <div class="container">
    <div
      class="head_bg bg_i_0"
      :class="{'bg_i_0':carouselIndex==0,'bg_i_1':carouselIndex==1,'bg_i_2':carouselIndex==2,}"
    >
      <comm-head></comm-head>
      <div class="carousel_item">
        <div>
          <p>{{$t('home.headTitle')}}</p>
          <p>{{$t('home.headContent')}}</p>
        </div>
        <div v-show="$i18n.locale=='zh'" @click="handleRouterSkip('Profile')">{{$t('home.headBtn')}}</div>
        <img :class="{'img_m_t':$i18n.locale=='en'}" src="../assets/images/logo.png" alt />
      </div>
    </div>
    <div class="bg_c_w">
      <business />
    </div>
    <div class="bg_c_g">
      <ai-lab />
    </div>
    <div class="bg_c_w">
      <core-advantage />
    </div>
    <div class="bg_c_g">
      <moment />
    </div>
    <foot-cpright></foot-cpright>
  </div>
</template>

<script>
import commHead from "@/components/comm-head.vue";
import footCpright from "@/components/foot-cpright.vue";
import business from "@/components/home/business.vue";
import aiLab from "@/components/home/aiLab.vue";
import coreAdvantage from "@/components/home/coreAdvantage.vue";
import moment from "@/components/home/moment.vue";

export default {
  components: {
    commHead,
    business,
    aiLab,
    coreAdvantage,
    moment,
    footCpright
  },
  data() {
    return {
      carouselIndex: 1
    };
  },

  created() {},
  methods: {
    handleRouterSkip(name, type) {
      const { handleOpenUrl } = this;
      if (type) {
        let url = this.$router.resolve({
          path: `/${name}`
        });
        handleOpenUrl(url.href);
      } else {
        this.$router.push({ name });
      }
    },
    handleOpenUrl(url) {
      window.open(url, "_blank");
    },
    handleCarouselChange(e) {
      this.carouselIndex = e;
    }
  }
};
</script>

<style lang="scss" scoped>
.f_s_24 {
  font-size: 24px;
}

.f_s_18 {
  font-size: 18px;
}

.f_w_b {
  font-weight: bold;
}

.bg_c_w {
  background-color: #fff;
}
.bg_c_g {
  background-color: #f7f7f7;
}

.mar-r-60 {
  margin-right: 60px;
}

.container {
  overflow-y: auto;
  background-image: url("../assets/images/banner_index.png");
  background-repeat: no-repeat;
  & .head_bg {
    height: 820px;
    & .carousel_item {
      width: 1200px;
      margin: 0 auto;
      height: 100%;
      padding-top: 160px;
      animation: text_animation 3s;
      & > div:nth-child(1) {
        width: 1000px;
        margin-bottom: 24px;
        & > p:nth-child(1) {
          font-size: 48px;
          color: #ff9200;
          letter-spacing: 0;
          margin-bottom: 10px;
        }
        & > p:nth-child(2) {
          font-size: 18px;
          color: #ffffff;
          letter-spacing: 0;
          line-height: 32px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
      }
      & > div:nth-child(2) {
        margin-bottom: 100px;
        width: 155px;
        height: 48px;
        background: #ff9200;
        border-radius: 24px;
        text-align: center;
        line-height: 48px;
        font-size: 18px;
        color: #feffff;
        letter-spacing: 0;
        cursor: pointer;
      }
      & > div:nth-child(2):hover {
        background: #ffa400;
      }
      & .img_m_t {
        margin-top: 148px;
      }
    }
  }
}

@keyframes text_animation {
  0% {
    opacity: 0;
    transform: translateY(-431px);
  }
  100% {
    opacity: 1;
    transform: translateY(0px);
  }
}

@keyframes opac_animation {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes shadow {
  0% {
    top: 257px;
  }
  100% {
    top: 0px;
  }
}
</style>